import {
  ErrorNotification,
  SuccessNotification,
  Text,
  WarningNotification,
} from '@epam/promo';
import { useUuiContext } from '@epam/uui-core';

const NOTIFICATION_LEVEL = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
} as const;

export const useToast = () => {
  const { uuiNotifications } = useUuiContext();

  const useSuccessToast = (message: string) =>
    uuiNotifications.show(({ key, id, onClose, onSuccess }) => (
      <SuccessNotification
        key={key}
        id={id}
        onClose={onClose}
        onSuccess={onSuccess}>
        <Text color="gray80">{message}</Text>
      </SuccessNotification>
    ));

  const useErrorToast = (message: string) =>
    uuiNotifications.show(({ key, id, onClose, onSuccess }) => (
      <ErrorNotification
        key={key}
        id={id}
        onClose={onClose}
        onSuccess={onSuccess}>
        <Text color="gray80">{message}</Text>
      </ErrorNotification>
    ));

  const useWarningToast = (message: string) =>
    uuiNotifications.show(({ key, id, onClose, onSuccess }) => (
      <WarningNotification
        key={key}
        id={id}
        onClose={onClose}
        onSuccess={onSuccess}>
        <Text color="gray80">{message}</Text>
      </WarningNotification>
    ));

  const toast = {
    [NOTIFICATION_LEVEL.SUCCESS]: useSuccessToast,
    [NOTIFICATION_LEVEL.ERROR]: useErrorToast,
    [NOTIFICATION_LEVEL.WARNING]: useWarningToast,
  };

  return toast;
};
